import RequiredProfile from './RequiredProfile';

export default RequiredProfile;


// WEBPACK FOOTER //
// ./src/components/pages/RequiredProfile/index.js